import React, { useCallback, useRef } from 'react'
import { useTheme } from '../ThemeContext'
import { SunIcon } from './SunIcon'
import { MoonIcon } from './MoonIcon'
import './themeToggler.css'

export const AnimatedThemeToggler = ({ className = '', duration = 400, ...props }) => {
  const { isDarkMode, toggleTheme } = useTheme()
  const buttonRef = useRef(null)

  const handleToggle = useCallback(async () => {
    if (!buttonRef.current) return

    // Comprovar si l'API View Transition està suportada
    if (!document.startViewTransition) {
      toggleTheme()
      return
    }

    await document.startViewTransition(() => {
      toggleTheme()
    }).ready

    const { top, left, width, height } = buttonRef.current.getBoundingClientRect()
    const x = left + width / 2
    const y = top + height / 2
    const maxRadius = Math.hypot(Math.max(left, window.innerWidth - left), Math.max(top, window.innerHeight - top))

    document.documentElement.animate(
      {
        clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${maxRadius}px at ${x}px ${y}px)`],
      },
      {
        duration,
        easing: 'ease-in-out',
        pseudoElement: '::view-transition-new(root)',
      }
    )
  }, [toggleTheme, duration])

  return (
    <button ref={buttonRef} onClick={handleToggle} className={`theme-toggle-btn ${className}`} aria-label='Toggle theme' {...props}>
      {isDarkMode ? <MoonIcon style={{ fontSize: '1.5em' }} /> : <SunIcon style={{ fontSize: '1.5em' }} />}
    </button>
  )
}
